/**
 * From the simulation's C64 screen coordinates to world units (spec 03 §3): playfield pixels
 * (x right, y down, 256x200) become tiles centred on the origin, y up. Sprites (players, monsters,
 * the Baron) are placed by the point under their feet; bubbles and items by their centre.
 */

import { Vector3 } from 'three';
import { spriteCentre, spriteFeet } from '../../sim/coords';

const COLS = 32;
const ROWS = 25;

/** Playfield pixel -> world units (the playfield plane, z = 0). */
export function pixelToWorld(px: number, py: number, out = new Vector3()): Vector3 {
  return out.set(px / 8 - COLS / 2, ROWS / 2 - py / 8, 0);
}

/** Where a sprite's feet are, in world units. */
export function feetToWorld(x: number, y: number, out = new Vector3()): Vector3 {
  const f = spriteFeet(x, y);
  return pixelToWorld(f.x, f.y, out);
}

/** Where a sprite's (or a bubble's, an item's) 16x16 body centre is, in world units. */
export function centreToWorld(x: number, y: number, out = new Vector3()): Vector3 {
  const c = spriteCentre(x, y);
  return pixelToWorld(c.x, c.y, out);
}

/**
 * Interpolate a coordinate between two sim frames; a jump of more than `wrap` pixels is a wrap
 * through the holes (or a respawn), which snaps instead of sweeping across the screen.
 */
export function lerpCoord(prev: number, cur: number, alpha: number, wrap = 48): number {
  return Math.abs(cur - prev) > wrap ? cur : prev + (cur - prev) * alpha;
}
